import {default as STOP_WORDS} from './stopWords.json';
export const stopWords: ReadonlySet<string> = new Set(([] as string[]).concat(...Object.values(STOP_WORDS || {})));
